import { cva } from '@/styled-system/css';

export const tableSortButtonRecipe = cva({
  base: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 'tighter',

    _focusVisible: {
      _before: {
        content: '""',
        position: 'absolute',
        inset: 0,
        boxShadow: 'focus',
        zIndex: 2,
      },
    },
  },
  variants: {
    align: {
      left: {},
      center: {},
      right: {},
      start: {},
      end: {},
    },
  },
  compoundVariants: [
    {
      align: ['start', 'left', 'center'],
      css: {
        flexDirection: 'row',
      },
    },
    {
      align: ['right', 'end'],
      css: {
        flexDirection: 'row-reverse',
      },
    },
  ],
});
